// Module Droit des Sociétés - Redirects to new Hub component
import DroitSocietesHub from "./corporate/DroitSocietesHub";

export default function DroitSocietes() {
  return <DroitSocietesHub />;
}
